import React from 'react';
import Modal from '../Common/Modal';
import './ContinuationModal.css';

/**
 * Modal shown when a session auto-continues due to message limit.
 *
 * @param {boolean} isOpen - Whether modal is visible
 * @param {function} onClose - Close handler
 * @param {string} newSessionId - ID of the new continuation session
 * @param {string} previousSessionId - ID of the completed session
 * @param {function} onViewPreviousSummary - Navigate to previous session summary
 */
export function ContinuationModal({
  isOpen,
  onClose,
  newSessionId,
  previousSessionId,
  onViewPreviousSummary
}) {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Session Continued">
      <div className="continuation-modal">
        <div className="continuation-modal__icon">🔄</div>
        <p className="continuation-modal__message">
          Your previous session reached the message limit and has been summarized.
          A new session has been created to continue your brainstorming.
        </p>
        <div className="continuation-modal__info">
          <div className="continuation-modal__info-item">
            <span className="continuation-modal__label">Previous Session:</span>
            <span className="continuation-modal__value">{previousSessionId?.slice(0, 8)}...</span>
          </div>
          <div className="continuation-modal__info-item">
            <span className="continuation-modal__label">New Session:</span>
            <span className="continuation-modal__value">{newSessionId?.slice(0, 8)}...</span>
          </div>
        </div>
        <p className="continuation-modal__note">
          Your conversation context has been preserved in the summary.
        </p>
        <div className="continuation-modal__actions">
          {onViewPreviousSummary && (
            <button
              className="continuation-modal__btn continuation-modal__btn--secondary"
              onClick={onViewPreviousSummary}
            >
              View Previous Summary
            </button>
          )}
          <button
            className="continuation-modal__btn continuation-modal__btn--primary"
            onClick={onClose}
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ContinuationModal;
